import React, { useEffect } from "react";
//
import dataProcessImg from "./dataProcessImg.json";
import dataProcessing3dMax from "./dataProcMax.json";
import dataBehindScenes from "./dataBehindScenes.json";
//lethe
import dataProcLetheImg from "./dataProcLethe.json";
//
// import ProcessCityimgHero from "./ProcessImgHero";
//
//
//
//
import heroProcessImg1 from "../../img_3d_chairs/cycles_realisticlighttest1_cube.jpg";

//
// import heroProcessImg2 from "../../img_3d_chairs/eeve_render3_house0.jpg";

// fade animation related AOS
import Aos from "aos";
import "aos/dist/aos.css";
//
// zoom in related
import { motion } from "framer-motion";
//<motion.  add this to any img you want to scale
// data-aos-duration="1000" ,adding this will make the anim go faster therefore the performance will be a bit better
//
//

const ProcessGrid = ({ setSelectedImgProcess }) => {
  //
  useEffect(() => {
    Aos.init({ duration: 3000 });
  }, []);
  //
  //
  //

  // test lights "houses"
  const imageCardProcess = dataProcessImg;
  // lethe
  const imageCardProcLethe = dataProcLetheImg;

  // behin Scenes
  const imageCardBehindScenes = dataBehindScenes;
  //
  //  city organic - 3ds MAX
  const imageCardProcMax = dataProcessing3dMax;
  // MERGE THESE TWO
  const allDataImgCards = [...imageCardProcess, ...imageCardProcLethe];

  return (
    <>
      <section id="process">
        <div className="process___wrapper">
          {/* 
          
          
          
          */}
          <div className="header__Top1">
            {/* heading */}{" "}
            <div className="header__Top1__title">
              <h1 data-aos-duration="1000" data-aos="fade-up">
                PROCESS
              </h1>
            </div>
            <div className="header__Top1__titleTab">
              <h2> Selected Works:</h2>
              <p> 2008 | 2021</p>
            </div>
          </div>
          {/* ---------- */}
          {/* ---------- */}
          <div className="descript__row">
            <div className="descript__row__wrapper">
              <div className="descript__row_heading">
                <h1 data-aos-duration="1000" data-aos="fade-up">
                  PREFACE
                </h1>
                <h2>Below:</h2>

                <p> Software Used: </p>
                <p>Blender | 3ds Max | Photoshop </p>
              </div>
              <div className="descript__row_article">
                <h1>
                  <br />
                  When I made the decision to branch out into a new field, after
                  a decade of working in the art world,
                  <span>
                    it was with the strong purpose of creating environments
                    based on my aesthetics.{" "}
                  </span>{" "}
                  I knew from the beginning that it would be a long way until I
                  reached that goal. This resulted in me learning as many skills
                  as I thought would be necessary to build a substantial
                  foundation in the field.
                </h1>
              </div>
            </div>
          </div>
          {/* HEADER Hero*/}
          {/* ------- */}
          <div className="header__heroImg">
            <div className="header__heroIm_wrapper">
              {/* img hero */}
              <div className="header__heroIm_container">
                <div className="img-box">
                  <img src={heroProcessImg1} alt="img city mono preview" />
                </div>
              </div>{" "}
            </div>
          </div>

          {/* 
          
          
          
          
          
          */}
          <div className="header__folio">
            {/* heading */}{" "}
            <div className="header__folio__title">
              <h1 data-aos-duration="1000" data-aos="fade-down">
                folio
              </h1>
              <h2>01</h2>
            </div>
            <div className="header__folio__titleTab">
              <h3> Software: Blender</h3>
              <p> March - August | 2021</p>
            </div>
          </div>
          {/* 
              
              
              
              
              
              
              */}
          {/* ---------- */}
          <div id="process___modal">
            <div className="processImg__Wrapper">
              <div className="processImg__container__grid">
                {/* ---dataCityOrganic---3Ds-MAX--data---- */}
                {allDataImgCards &&
                  allDataImgCards.map((allDataMerged, index) => (
                    <div
                      className="processImg_card"
                      key={index}
                      onClick={() =>
                        setSelectedImgProcess(allDataMerged.img1Process)
                      }
                    >
                      <div className="img_box_process">
                        <img
                          src={allDataMerged.img1Process}
                          alt={allDataMerged.alt}
                        />
                      </div>

                      {/* <p>
                        {allDataMerged.text1}{" "}
                        <span>{allDataMerged.text2} </span>
                      </p> */}
                    </div>
                  ))}
                {/* ------------- */}
              </div>
            </div>
          </div>
          {/* ---------- */}
          {/* ---------- */}
          {/* ---------- 
          
          
          */}
          {/* ---------- */}
          {/* ---------- */}
          <div className="header__folio">
            {/* heading */}{" "}
            <div className="header__folio__title">
              <h1 data-aos-duration="1000" data-aos="fade-down">
                folio
              </h1>
              <h2>02</h2>
            </div>
            <div className="header__folio__titleTab">
              <h3> Software: Studio 3Ds Max</h3>
              <p> 2016</p>
            </div>
          </div>
          {/* ---------- */}
          <div id="process___modal">
            <div className="processImg__Wrapper">
              <div className="processImg__container__grid">
                {imageCardProcMax &&
                  imageCardProcMax.map((itemOrganic) => (
                    <div
                      className="processImg_card"
                      key={itemOrganic.id}
                      onClick={() =>
                        setSelectedImgProcess(itemOrganic.img1Process)
                      }
                    >
                      <div className="img_box_process">
                        <img
                          src={itemOrganic.img1Process}
                          alt={itemOrganic.alt}
                        />
                      </div>

                      {/* <p>
                        {itemOrganic.text1} <span>{itemOrganic.text2} </span>
                      </p> */}
                    </div>
                  ))}
                {/* ------------- */}
              </div>
            </div>
          </div>
          {/* ---------- */}
          <div className="folio_BG_scroll">
            {/* heading */}
            <div className="folio_BG_scroll_containerImg"></div>
          </div>
          {/* 
             
             
             
             
             
             
             - */}

          <div className="header__folio">
            {/* heading */}{" "}
            <div className="header__folio__title">
              <h1 data-aos-duration="1000" data-aos="fade-down">
                folio
              </h1>{" "}
              <h2>03</h2>
            </div>
            <div className="header__folio__titleTab">
              <h3>Behing Scenes</h3>
              <p> 2016 | 2021</p>
            </div>
          </div>
          {/* -----BEHIND SCENES----- */}
          <div id="behindScenes___modal">
            <div className="behindScenesImg__Wrapper">
              <div className="behindScenesImg__container__grid">
                {imageCardBehindScenes.map((itemBehindScenes) => (
                  <div
                    className="behindScenesImg_card"
                    key={itemBehindScenes.id}
                  >
                    <div className="img_box_behindScenes">
                      <motion.img
                        data-aos="fade-up-right"
                        whileHover={{ scale: 1.2 }}
                        onHoverStart={(eImg) => {}}
                        onHoverEnd={(eImg) => {}}
                        src={itemBehindScenes.img1Process}
                        alt={itemBehindScenes.alt}
                      />
                    </div>

                    <p>
                      {itemBehindScenes.text1}{" "}
                      <span>{itemBehindScenes.text2} </span>
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
          {/* ---------- */}
          {/* ---------- */}
          {/* ---------- */}
        </div>
      </section>
    </>
  );
};

//

export default ProcessGrid;
